import React from 'react'
import SALink from 'components/SALink'
import { Breadcrumbs } from 'styles/breadcrumbs'
import { HOME_TOOLTIP, ALL_ARTWORKS_TOOLTIP } from '../helpers/constants'
export default (): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <Breadcrumbs>
      <SALink title={HOME_TOOLTIP} href='/'>
        Home
      </SALink>
      <SALink title={ALL_ARTWORKS_TOOLTIP} href='/all'>
        All Artworks
      </SALink>
    </Breadcrumbs>
  )
}